import {createRoot} from "react-dom/client";
import {TeamInsights} from "./ui/TeamInsights";

/**
 * Boot config passed from the JSP (via the {@code jsConstants} view model).
 */
export interface TeamInsightsConfig {
	baseUrl?: string;
}

const MOUNT_ID = "teamInsightsRoot";

/**
 * Page entry registered in the {@code Pages} namespace and instantiated from the JSP via
 * {@code new Pages.TeamInsightsPage(jsConstants)}. Mounts the React dashboard into the page.
 */
export class TeamInsightsPage {
	constructor(_config: TeamInsightsConfig) {
		const container = document.getElementById(MOUNT_ID);
		if (!container) {
			throw new Error(`React mount target #${MOUNT_ID} was not found`);
		}
		createRoot(container).render(<TeamInsights/>);
	}
}
